import { uiRows } from './types-def.js';
/** `web/review` (3.E): proposal review after a session. */
export const REVIEW_INTERACTIONS = uiRows([
    {
        id: 'review.proposal.accept',
        module: 'web/review',
        behavior: 'A accepts the focused proposal',
        owner: '3.E',
        since: 'exit-3b',
    },
    {
        id: 'review.proposal.edit',
        module: 'web/review',
        behavior: 'E opens the proposal for editing, then accepts it',
        owner: '3.E',
        since: 'exit-3b',
    },
    {
        id: 'review.proposal.reject',
        module: 'web/review',
        behavior: 'X rejects the focused proposal',
        owner: '3.E',
        since: 'exit-3b',
    },
    {
        id: 'review.evidence.jump',
        module: 'web/review',
        behavior: 'An evidence quote jumps to its transcript line',
        owner: '3.E',
        since: 'exit-3b',
    },
    {
        id: 'review.group.accept',
        module: 'web/review',
        behavior: 'A group is accepted after a preview, in dependency order',
        owner: '3.E',
        since: 'exit-3b',
    },
]);
//# sourceMappingURL=review.js.map